import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { AUTH_LIGHT_SCREEN_BG, useBodyBackgroundOnMount } from '../hooks/useBodyBackgroundOnMount';
import { signOutAuth } from '../lib/supabaseAuth';
import { clearMemberSession, clearSession } from '../lib/auth';

export default function DeveloperSignOutPage() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState<string | null>(null);

  useBodyBackgroundOnMount(AUTH_LIGHT_SCREEN_BG);

  const handleSignOut = async () => {
    setLoading(true);
    setMessage(null);
    try {
      clearSession();
      clearMemberSession();
      await signOutAuth();
      setMessage('サインアウトしました。');
    } catch (error) {
      clearSession();
      clearMemberSession();
      setMessage('サインアウト状態にしました。');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-teal-50 to-blue-50 flex items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <CardTitle className="text-2xl font-bold text-teal-600">Handra</CardTitle>
          <CardDescription>開発用サインアウト</CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-sm text-gray-700">
            開発中にセッションを切り直したいとき用の画面です。
          </p>
          {message && (
            <p className="text-sm text-green-600" role="status">
              {message}
            </p>
          )}
          <div className="space-y-2">
            <Button
              type="button"
              variant="cta"
              className="w-full"
              onClick={handleSignOut}
              disabled={loading}
            >
              {loading ? 'サインアウト中...' : 'サインアウトする'}
            </Button>
            <Button
              type="button"
              variant="outline"
              className="w-full"
              onClick={() => navigate('/login')}
              disabled={loading}
            >
              ログイン画面へ
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
